/**
 * お知らせ配信管理
 */

import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Typography,
    Button,
    Grid,
    DialogTitle
} from '@material-ui/core';
import CustomizedSearchInput from 'mdoc/utils/CustomizedSearchInput';
import {
    getNotifySearch
} from 'mdoc/admin/axios/notify'
import { dictionary, getPermissions } from 'mdoc/admin/axios'
import {
    notifyDelete
} from 'mdoc/admin/axios/notify'
import CustomizedTable from 'mdoc/utils/table'
import { Link } from 'react-router-dom'
import * as config from 'mdoc/admin/axios/config'
import Dialog from 'mdoc/utils/myDialog'
import Toast from 'mdoc/utils/toast';

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    bootstrapSearch: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        padding: '7px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    link: {
        color: '#2196f3',
        textDecoration: 'none'
    },
    margin: {
        margin: theme.spacing.unit
    },
    title: {
        marginLeft: '-20px'
    }
});

class NotifyManagement extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        data: [],
        loading: false,
        pagination: {
            pageNumber: 1,
            pageSize: 25,
            count: 0,
            sidx: '',
            sord: ''
        },
        dictWord: {
            'management': '',
            'notification_release_registration': '',
            'notice_open_state': '',
            'open_start_date': '',
            'notice_title': '',
            'modify_record': '',
            'delete_record': '',
            'copy_record': '',
            'published': '',
            'non_public': '',
            'under_reservation': '',
            'msg_confirm_really_delete': '',
            'yes': '',
            'cancel': '',
            'msg_error_record_not_found': '',
            'confirmation': '',
        },
        noticeTitle: '',
        openStatus: config['NOTIFY_STATUS'],
        dialogOpen: false,
        noticeId: '',
        search: '',
        permissions: [],
    }
    componentWillMount() {
        this.start(this.state);
    }
    componentDidMount() {
        const permissions = getPermissions() !== undefined ? getPermissions() : [];
        this.setState({
            permissions: permissions
        });
    }
    start = (state) => {
        this.setState({ loading: true });
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
    }


    fetch = (params = {}) => {
        this.setState({ loading: true })
        getNotifySearch({
            ...params
        }).then((data) => {
            const pagination = { ...this.state.pagination, ...params }
            pagination.count = data.count;
            if (data.results === undefined) {
                Toast.info(this.state.dictWord.msg_error_record_not_found)
            }
            this.setState({
                loading: false,
                data: data.results !== undefined ? data.results : [],
                pagination: pagination,
            })
        }).catch(error => {
            Toast.info(error)
        })
    }

    handleTableChange = (event, pagination) => {
        this.fetch({
            noticeTitle: this.state.search,
            pageNumber: pagination.page,
            pageSize: pagination.rowsPerPage,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    }
    handleTableSort = (event, property) => {
        const sidx = property;
        let sord = 'desc';

        let pagination = this.state.pagination;
        if (pagination.sidx === property && pagination.sord === 'desc') {
            sord = 'asc';
        }
        pagination['sord'] = sord;
        pagination['sidx'] = sidx;
        this.setState({
            pagination: pagination
        });
        this.fetch({
            noticeTitle: this.state.search,
            pageNumber: this.state.pagination.pageNumber,
            pageSize: this.state.pagination.pageSize,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    };
    //削除
    handleSubmit = (noticeId) => event => {
        this.setState({
            noticeId: noticeId,
            dialogOpen: true
        });
    }
    dialogHandleOK = (event) => {
        notifyDelete(this.state.noticeId).then(res => {
            window.location.reload()
        }).catch(function (error) {
            Toast.error(error);
        })
    }
    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false
        });
    }
    handleSearch(keyWords) {
        this.setState({
            search: keyWords
        }, () => {
            this.fetch({
                noticeTitle: keyWords,
                pageNumber: this.state.pagination.pageNumber,
                pageSize: this.state.pagination.pageSize,
                sidx: this.state.pagination.sidx,
                sord: this.state.pagination.sord,
            })
        });
    }
    render() {
        const { classes } = this.props;
        const { permissions } = this.state;
        const columns = [
            {
                title: this.state.dictWord.notice_open_state,
                dataIndex: 'openStatus',
                width: '129px',
                render: (text, record) => {
                    if (record['openStatus'] === 0) {
                        let time = new Date();
                        time.setSeconds(0);
                        let openTime = new Date(record['openTime']);
                        openTime.setSeconds(0);
                        if (time.getTime() < openTime.getTime()) {
                            return this.state.dictWord[this.state.openStatus[2]];
                        } else {
                            return this.state.dictWord[this.state.openStatus[0]];
                        }
                    } else if (record['openStatus'] === 1) {
                        return this.state.dictWord[this.state.openStatus[text]];
                    }
                },

            }, {
                title: this.state.dictWord.open_start_date,
                dataIndex: 'openTimeStr',
                sortIndex: 'openTime',
                sorter: true,
                width: '177px',
            }, {
                title: this.state.dictWord.notice_title,
                dataIndex: 'noticeTitle',
                width: '209px',
            },
        ]
        if (permissions.includes(6)) {
            columns.push({
                title: this.state.dictWord.management,
                key: 'action',
                toolTipDisabled: true,
                width: '200px',
                style:{
                    overflow: 'none',
                },
                render: (text, record) => {
                    let time = new Date();
                    time.setSeconds(0);
                    let openTime = new Date(record['openTime']);
                    openTime.setSeconds(0);
                    return <span>
                        <Link to={{ pathname: '/admin/notify/notifymanagement_edit', state: { noticeId: record.noticeId } }} className={classes.margin} style={{ textDecoration: 'none' }}>
                            <Button variant="contained" color="primary">{this.state.dictWord.copy_record}</Button>
                        </Link>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit(record.noticeId)} className={classes.margin}>{this.state.dictWord.delete_record}</Button>
                        {parseInt(record['openStatus']) === 1 || time.getTime() < openTime.getTime() ?
                            <Button variant="contained" color="primary" className={classes.margin} href={'/admin.html#/admin/notify/notifymanagement_edit/' + record.noticeId}>{this.state.dictWord.modify_record}</Button>
                            : null
                        }
                    </span>
                },
            })
        }
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                <Grid container direction="row" justify="space-between" alignItems="center" >
                    <Grid item xs={12} md={6}>
                        {permissions.includes(6) ? <Button variant="contained" color="primary" className={classes.margin} href={'/admin.html#/admin/notify/notifymanagement_edit'}>
                            {this.state.dictWord.notification_release_registration}
                        </Button> : null}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <CustomizedSearchInput onClick={this.handleSearch.bind(this)} />
                    </Grid>
                </Grid>
                <Typography component="div" className={classes.margin}>
                    <CustomizedTable
                        data={this.state.data}
                        columns={columns}
                        count={this.state.pagination.count}
                        page={this.state.pagination.pageNumber}
                        rowsPerPage={this.state.pagination.pageSize}
                        onChange={this.handleTableChange}
                        sord={this.state.pagination.sord}
                        sidx={this.state.pagination.sidx}
                        onSort={this.handleTableSort}
                    />
                </Typography>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dictWord['msg_confirm_really_delete']}</p>
                    }
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
            </div>
        )
    }
}

NotifyManagement.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NotifyManagement);